/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class MathLinesInst extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.instSound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.popUp = this.scene.add.container();
    this.add(this.popUp);

    const pBg = ABCyaPhaser.Images.addImage(0, 0, 'inst-bg', this.popUp).setOrigin(0, 0);
    pBg.y = -(pBg.getBounds().height / 2);
    pBg.x = -(pBg.getBounds().width / 2);

    const instTitle = ABCyaPhaser.Images.addImage(0, 0, 'inst-title', this.popUp).setOrigin(0, 0);
    instTitle.x = -(instTitle.getBounds().width / 2);
    instTitle.y = -(pBg.getBounds().height / 2) + 20;

    const addTxt = ABCyaPhaser.Text.addText(0, 0, 28, '0x699541', FontKeys._odin_roundedregular, 'CLEAR THE BALLS BY FORMING PAIRS THAT\nMULTIPLY TO THE NUMBER YOU SELECTED.', this.popUp, false);
    addTxt.x = -(pBg.getBounds().width / 2) + 25;
    addTxt.y = instTitle.y + instTitle.getBounds().height + 30;
    addTxt.lineHeight = 30;

    const noteTxt = ABCyaPhaser.Text.addText(0, 0, 28, '0x699541', FontKeys._odin_roundedregular, 'NOTE: YOU CAN USE ONE BALL TO CLEAR A\nGROUP OF SAME-NUMBERED BALLS.', this.popUp, false);
    noteTxt.y = addTxt.y + addTxt.height + 45;
    noteTxt.x = -(pBg.getBounds().width / 2) + 25;
    noteTxt.lineHeight = 30;

    this.popUp.x = this.scene.mid.x;
    this.popUp.y = this.scene.mid.y - 100;
    this.popUp.scaleX = 0;
    this.popUp.scaleY = 0;
    this.popUp.alpha = 0;

    this.goBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'btnStart', null, () => {
      this.goBtn.setEnabled(false);
      this.finishInst();
    }, this, { disabledTint: '0xFFFFFF' }).setEnabled(false);
    this.goBtn.x = this.scene.mid.x;
    this.goBtn.y = this.scene.mid.y + 120;
    this.goBtn.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.popUp, 1000, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.goBtn, 300, { delay: 600, alpha: 1 }, Phaser.Math.Easing.Back.Out, () => {
      this.instReady();
    });
  }

  instReady() {
    this.goBtn.setEnabled(true);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._math_lines_multi_instruction, this.instSound);
    this.instSound.once('complete', () => {this.finishVoice();});
  };

  finishVoice() {
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._math_lines_instructions_2, this.instSound);
  };

  finishInst() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.instSound.stop();

    ABCyaPhaser.Tweens.addTween(this.goBtn, 300, { alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.popUp, 1000, { scale: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.cleanUp();
    });
  };

  cleanUp() {
    this.emit('INST_FINISHED');

    this.removeAll(true);
  };
}